module.exports = __webpack_public_path__ + "img/logo-removebg.5e75a39b.png";